theme._Drawers = (function() {
    function Drawer(id, name, ignoreScrollLock) {
        this.config = {
            id: id,
            close: '.js-drawer-close',
            open: '.js-drawer-open-' + name,
            openClass: 'js-drawer-open',
            closingClass: 'js-drawer-closing',
            activeDrawer: 'drawer--is-open',
            namespace: '.drawer-' + name
        };

        this.$nodes = {
            parent: $(document.documentElement).add('body'),
            page: $('#MainContent')
        };

        this.$drawer = $('#' + id);

        if (!this.$drawer.length) {
            return false;
        }

        this.isOpen = false;
        this.ignoreScrollLock = ignoreScrollLock;
        this.init();
    };

    Drawer.prototype = $.extend({}, Drawer.prototype, {
        init: function() {
            var $openBtn = $(this.config.open);

            // Add aria controls
            $openBtn.attr('aria-expanded', 'false');

            $openBtn.on('click', this.open.bind(this));
            this.$drawer.find(this.config.close).on('click', this.close.bind(this));
        },

        open: function(evt) {
            if (evt) {
                evt.preventDefault();
            }

            if (this.isOpen) {
                return;
            }

            // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
            if (evt && evt.stopPropagation) {
                evt.stopPropagation();
                // save the source of the click, we'll focus to this on close
                this.$activeSource = $(evt.currentTarget);
            }

            this.$drawer.prepareTransition().addClass(this.config.activeDrawer);

            this.$nodes.parent.addClass(this.config.openClass);
            this.isOpen = true;

            slate.a11y.trapFocus({
                $container: this.$drawer,
                namespace: 'drawer_focus'
            });

            $('body').trigger('drawerOpen.' + this.config.id);

            if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
                this.$activeSource.attr('aria-expanded', 'true');
            }

            this.bindEvents();
        },

        close: function() {
            if (!this.isOpen) {
                return;
            }

            // deselect any focused form elements
            $(document.activeElement).trigger('blur');

            this.$drawer.prepareTransition().removeClass(this.config.activeDrawer);

            this.$nodes.parent.removeClass(this.config.openClass);
            this.$nodes.parent.addClass(this.config.closingClass);
            var o = this;
            window.setTimeout(function() {
                o.$nodes.parent.removeClass(o.config.closingClass);
            }, 500);

            this.isOpen = false;

            slate.a11y.removeTrapFocus({
                $container: this.$drawer,
                namespace: 'drawer_focus'
            });

            if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
                this.$activeSource.attr('aria-expanded', 'false');
            }

            this.unbindEvents();
        },

        bindEvents: function() {
            if (!this.ignoreScrollLock) {
                slate.a11y.lockMobileScrolling(this.config.namespace, this.$nodes.page);
            }

            // Clicking out of drawer closes it.
            // Check to see if clicked on element in drawer
            // because of any drawer built witin #MainContent
            this.$nodes.page.on('click' + this.config.namespace, function (evt) {
                var $target = $(evt.target);
                var doNotClose = this.elementInsideDrawer($target);
                if (!doNotClose) {
                    this.close();
                    return false;
                }

            }.bind(this));

            // Pressing escape closes drawer
            this.$nodes.parent.on('keyup' + this.config.namespace, function(evt) {
                if (evt.keyCode === 27) {
                    this.close();
                }
            }.bind(this));
        },

        unbindEvents: function() {
            if (!this.ignoreScrollLock) {
                slate.a11y.unlockMobileScrolling(this.config.namespace, this.$nodes.page);
            }
            this.$nodes.parent.off(this.config.namespace);
            this.$nodes.page.off(this.config.namespace);
        },

        // Check if clicked element is inside the drawer
        elementInsideDrawer: function($el) {
            return this.$drawer.find($el).length;
        }
    });

    return Drawer;
})();

theme.cart = {
    getCart: function() {
        return $.getJSON('/cart.js');
    },

    changeItem: function(key, qty) {
        return this._updateCart({
            type: 'POST',
            url: '/cart/change.js',
            data: 'quantity=' + qty + '&id=' + key,
            dataType: 'json'
        });
    },

    addItemFromForm: function(data) {
        return this._updateCart({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json'
        });
    },

    _updateCart: function(params) {
        return $.ajax(params)
            .then(function(cart) {
                return cart;
            }.bind(this))
    },

    updateNote: function(note) {
        var params = {
            type: 'POST',
            url: '/cart/update.js',
            data: 'note=' + theme.cart.attributeToString(note),
            dataType: 'json',
            success: function(cart) {},
            error: function(XMLHttpRequest, textStatus) {}
        };

        $.ajax(params);
    },
    updateAttribute: function(attr) {

        if(attr.is(":checked")){
            var dataParam = {
                attributes:{
                    'Required Help':'Yes'
                }
            }
        }else{
            var dataParam = {
                attributes:{
                    'Required Help':''
                }
            }
        }

        var params = {
            type: 'POST',
            url: '/cart/update.js',
            data: dataParam,
            dataType: 'json',
            success: function(cart) {},
            error: function(XMLHttpRequest, textStatus) {}
        };

        $.ajax(params);
    },

    attributeToString: function(attribute) {
        if ((typeof attribute) !== 'string') {
            attribute += '';
            if (attribute === 'undefined') {
                attribute = '';
            }
        }
        return $.trim(attribute);
    }
};

theme.QtySelector = (function() {
    var classes = {
        input: '.js-qty__num',
        plus: '.js-qty__adjust--plus',
        minus: '.js-qty__adjust--minus'
    };

    function QtySelector($el, options) {
        this.$wrapper = $el;
        this.$originalInput = $el.find('input[type="number"]');
        this.minValue = this.$originalInput.attr('min') || 1;

        var defaults = {
            namespace: null
        };

        this.options = $.extend(defaults, options);

        this.source = $('#JsQty').html();
        this.template = Handlebars.compile(this.source);

        var quantities = {
            current: this._getOriginalQty(),
            add: this._getOriginalQty() + 1,
            minus: this._getOriginalQty() - 1
        };

        this.data = {
            key: this._getProductKey(),
            itemQty: quantities.current,
            itemAdd: quantities.add,
            itemMinus: quantities.minus,
            inputName: this._getInputName(),
            inputId: this._getId()
        }

        // Append new quantity selector then remove original
        this.$originalInput.after(this.template(this.data)).remove();
        this.$input = this.$wrapper.find(classes.input);
        this.$plus = this.$wrapper.find(classes.plus);
        this.$minus = this.$wrapper.find(classes.minus);

        this.initEventListeners();
    };

    QtySelector.prototype = $.extend({}, QtySelector.prototype, {
        _getProductKey: function() {
            return this.$originalInput.data('id') || null;
        },

        _getOriginalQty: function() {
            return parseInt(this.$originalInput.val());
        },

        _getInputName: function() {
            return this.$originalInput.attr('name');
        },

        _getId: function() {
            return this.$originalInput.attr('id');
        },

        initEventListeners: function() {
            this.$plus.on('click', function() {
                var qty = this.validateQty(this.$input.val());
                this.addQty(qty);
            }.bind(this));

            this.$minus.on('click', function() {
                var qty = this.validateQty(this.$input.val());
                this.subtractQty(qty);
            }.bind(this));

            this.$input.on('change', function() {
                var qty = this.validateQty(this.$input.val());
                this.changeQty(qty);
            }.bind(this));
        },

        addQty: function(number) {
            var qty = number + 1;
            this.changeQty(qty);
        },

        subtractQty: function(number) {
            var qty = number - 1;
            if (qty <= this.minValue) {
                qty = this.minValue;
            }
            this.changeQty(qty);
        },

        changeQty: function(qty) {
            this.$input.val(qty);
            $('body').trigger('qty' + this.options.namespace, [this.data.key, qty]);
        },

        validateQty: function(number) {
            if((parseFloat(number) == parseInt(number)) && !isNaN(number)) {
                // We have a valid number!
            } else {
                // Not a number. Default to 1.
                number = 1;
            }
            return parseInt(number);
        }
    });

    return QtySelector;
})();

theme.CartDrawer = (function() {
    var config = {
        namespace: '.ajaxcart'
    };

    var selectors = {
        drawer: '#CartDrawer',
        container: '#CartContainer',
        template: '#CartTemplate',
        fixedFooter: '.drawer__footer--fixed',
        fixedInnerContent: '.drawer__inner--has-fixed-footer',
        cartBubble: '.cart-link__bubble'
    };

    function CartDrawer() {
        this.status = {
            loaded: false,
            loading: false
        };

        this.qtySelectors = [];

        this.drawer = new theme._Drawers('CartDrawer', 'cart');

        // Prep handlebars template
        var source = $(selectors.template).html();

        this.template = Handlebars.compile(source);

        // Build cart on page load so it's ready in the drawer
        theme.cart.getCart().then(this.buildCart.bind(this));

        this.initEventListeners();
    };

    CartDrawer.prototype = $.extend({}, CartDrawer.prototype, {
        initEventListeners: function() {
            $('body').on('updateCart' + config.namespace, this.initQtySelectors.bind(this));
            $('body').on('updateCart' + config.namespace, this.sizeFooter.bind(this));
            $('body').on('updateCart' + config.namespace, this.updateCartNotification.bind(this));
            $('body').on('drawerOpen.CartDrawer', this.sizeFooter.bind(this));

            $(window).on('resize' + config.namespace, $.debounce(150, this.sizeFooter.bind(this)));

            $('body').on('added.ajaxProduct', function() {
                theme.cart.getCart().then(function(cart) {
                    this.buildCart(cart, true);
                }.bind(this));
            }.bind(this));
        },

        buildCart: function(cart, openDrawer) {
            this.loading(true);
            this.emptyCart();

            if (cart.item_count === 0) {
                $(selectors.container).append('<p class="appear-animation appear-delay-3">' + theme.strings.cartEmpty +'</p>');
            } else {
                var items = [];
                var item = {};
                var data = {};
                var animation_row = 1;

                $.each(cart.items, function(index, product) {

                    var prodImg;
                    if (product.image !== null) {
                        prodImg = product.image.replace(/(\.[^.]*)$/, "_180x$1");
                    } else {
                        prodImg = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
                    }

                    if (product.properties !== null) {
                        $.each(product.properties, function(key, value) {
                            if (key.charAt(0) === '_' || !value) {
                                delete product.properties[key];
                            }
                        });
                    }

                    animation_row+=2;

                    item = {
                        key: product.key,
                        url: product.url,
                        img: prodImg,
                        animationRow: animation_row,
                        name: product.product_title,
                        variation: product.variant_title,
                        properties: product.properties,
                        itemQty: product.quantity,
                        price: theme.Currency.formatMoney(product.price, theme.moneyFormat),
                        discountedPrice: theme.Currency.formatMoney((product.price - (product.total_discount/product.quantity)), theme.moneyFormat),
                        discounts: product.discounts,
                        discountsApplied: product.price === (product.price - product.total_discount) ? false : true,
                        vendor: product.vendor
                    };

                    items.push(item);
                });

                animation_row+=2;

                // console.log(theme.strings);
                data = {
                    items: items,
                    note: cart.note,
                    lastAnimationRow: animation_row,
                    totalPrice: theme.Currency.formatMoney(cart.total_price, theme.moneyFormat),
                    totalCartDiscount: cart.total_discount === 0 ? 0 : theme.Currency.formatMoney(cart.total_discount, theme.moneyFormat)
                };

                $(selectors.container).append(this.template(data));
            }

            this.status.loaded = true;
            this.loading(false);

            if ($('body').hasClass('currencies-enabled')) {
                theme.currencySwitcher.ajaxrefresh();
            }

            $('body').trigger('updateCart' + config.namespace, cart);

            if (window.Shopify && Shopify.StorefrontExpressButtons) {
                Shopify.StorefrontExpressButtons.initialize();

                // Resize footer after arbitrary delay for buttons to load
                setTimeout(function() {
                    this.sizeFooter();
                }.bind(this), 800);
            }

            // If specifically asked, open the cart drawer (only happens after product added from form)
            if (openDrawer === true) {
                this.drawer.open();
            }
            $('#req_help').change(function(){
                theme.cart.updateAttribute($(this));
            })
        },

        initQtySelectors: function() {
            this.qtySelectors = [];

            $(selectors.container).find('.js-qty').each(function(index, el) {
                var selector = new theme.QtySelector($(el), {
                    namespace: '.cart-drawer'
                });
                this.qtySelectors.push(selector);
            }.bind(this));

            $('body').on('qty.cart-drawer', this.updateItem.bind(this));
        },

        updateItem: function(evt, key, qty) {
            if (this.status.loading) {
                return;
            }

            this.loading(true);

            theme.cart.changeItem(key, qty)
                .then(function(cart) {
                    this.updateSuccess(cart);
                }.bind(this))
                .always(function() {
                    this.loading(false);
                }.bind(this));
        },

        loading: function(state) {
            this.status.loading = state;

            if (state) {
                $(selectors.container).addClass('is-loading');
            } else {
                $(selectors.container).removeClass('is-loading');
            }
        },

        emptyCart: function() {
            $(selectors.container).empty();
        },

        updateSuccess: function(cart) {
            this.buildCart(cart)
        },

        updateError: function(XMLHttpRequest) {
            if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
                console.warn(XMLHttpRequest.responseJSON.description);
            }
        },

        // Update elements after cart is updated
        sizeFooter: function() {
            // Stop if our drawer doesn't have a fixed footer
            if (!$(selectors.drawer).hasClass('drawer--has-fixed-footer')) {
                return;
            }

            // Elements are reprinted regularly so selectors are not cached
            var $cartFooter = $(selectors.drawer).find(selectors.fixedFooter).removeAttr('style');
            var $cartInner = $(selectors.drawer).find(selectors.fixedInnerContent).removeAttr('style');
            var cartFooterHeight = $cartFooter.outerHeight();

            $cartInner.css('bottom', cartFooterHeight);
            $cartFooter.css('height', cartFooterHeight);
        },

        updateCartNotification: function(evt, cart) {
            if (cart.items.length > 0) {
                $(selectors.cartBubble).addClass('cart-link__bubble--visible');
            } else {
                $(selectors.cartBubble).removeClass('cart-link__bubble--visible');
            }
        }
    });

    return CartDrawer;
})();

theme.AjaxProduct = (function() {
    var status = {
        loading: false
    };

    function ProductForm($form) {
        this.$form = $form;
        this.$addToCart = this.$form.find('.add-to-cart');

        console.log($form)

        if (this.$form.length) {
            this.$form.on('submit', this.addItemFromForm.bind(this));
        } else {
            return false;
        }
    };

    ProductForm.prototype = $.extend({}, ProductForm.prototype, {
        addItemFromForm: function(evt, callback){
            evt.preventDefault();

            if (status.loading) {
                return;
            }

            // Loading indicator on add to cart button
            this.$addToCart.addClass('btn--loading');

            status.loading = true;

            var data = this.$form.serialize();

            theme.cart.addItemFromForm(data)
                .then(function(product) {
                    this.success(product);
                }.bind(this))

                .always(function() {
                    status.loading = false;
                    this.$addToCart.removeClass('btn--loading');
                }.bind(this));
        },

        success: function(product) {
            this.$form.find('.errors').remove();
            $('body').trigger('added.ajaxProduct');
        },

        error: function(XMLHttpRequest) {
            this.$form.find('.errors').remove();

            if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
                console.warn(XMLHttpRequest.responseJSON.description);

                this.$form.prepend('<div class="errors text-center">' + XMLHttpRequest.responseJSON.description + '</div>');
            }
        }
    });

    return ProductForm;
})();

$(function () {
    //if (theme.settings.cartType === 'drawer') {

    //}
    new theme.CartDrawer();
});
